/**
 * This dialog is used to display scheduled update validation errors to the user
 *
 * @author David Dong (ddong@yext.com)
 */

goog.module('yext.scheduledupdates.dialog.ValidationErrorDialog');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const dialog = goog.require('yext.dialog');
const Base = goog.require('yext.scheduledupdates.dialog.Base');
const time = goog.require('yext.time');

/**
 * Creates a dialog used for displaying Scheduled Update validation errors

 * @constructor
 * @param {int}     numSelectedField  the number of selected fields
 * @param {!Array}   errorData         data about the error
 * @param {string}  date              date to display
 */
const ValidationErrorDialog = function(numSelectedField, errorData, date) {
  this.numSelectedField = numSelectedField ? numSelectedField : 1;
  this.errorData = errorData;
  this.date = date;

  this.$dialog = $('.js-validation-error-dialog');

  this.options = {
    container: this.$dialog,
    title: yext.msg('Scheduled Updates Errors'),
  };

  Base.call(this, this.options);
};
goog.inherits(ValidationErrorDialog, Base);

/**
 * Add each field list DOM elements
 */
ValidationErrorDialog.prototype.fillErrorLists = function() {
  var $listEle = this.$dialog.find('.js-dialog-list');
  for (var i=0; i<this.errorData.length; i++) {
    var error = this.errorData[i];
    $listEle.append($(this.getContentForData(error)));
  }
};

/**
 * Returns the DOM element string for each field list
 * @param {!Object} data
 * @return {string}
 */
ValidationErrorDialog.prototype.getContentForData = function(error) {
  return '<li>' +
            '<p><strong>' + error.field_display_name + '</strong><br>' + error.error_message + '</p>' +
          '</li>';
};

/**
 * Add message to the .dialog-message DOM
 */
ValidationErrorDialog.prototype.fillDialogMessage = function() {
  var $msgEle = this.$dialog.find('.js-dialog-message');
  $msgEle.append($(this.getDialogMessage()));
};

/**
 * Return the dialog message string
 * @return {string}
 */
ValidationErrorDialog.prototype.getDialogMessage = function() {
  return '<p>' +
            // TRANSLATORS: numSelectedField is the number of selected fields in the update,
            //              it's just used to determine the nouns.
            //              date is the date appeared in the dialog
            // EXAMPLE:     Your selected fields cannot be applied to 2017-04-28.
            yext.msgn('Your selected field cannot be applied to {1}. ',
              'Your selected fields cannot be applied to {1}. ',
              this.numSelectedField, time.formatLocalizedDate(this.date, 'medium')) +
            // TRANSLATORS: errorData.length is the number of errors to display.
            //              It's just used to determine the nouns.
            // EXAMPLE:     There are errors in the following fields:
            yext.msgn('There is an error in the following field:',
              'There are errors in the following fields:', this.errorData.length) +
          '</p>';
};

/**
 * Clear message and list elements
 */
ValidationErrorDialog.prototype.clearElements = function() {
  this.$dialog.find('.js-dialog-message').empty();
  this.$dialog.find('.js-dialog-list').empty();
};

/**
 * Displays the dialog
 */
ValidationErrorDialog.prototype.show = function() {
  this.clearElements();
  this.fillDialogMessage();
  this.fillErrorLists();
  Base.prototype.show.call(this);
};

exports = ValidationErrorDialog;
